﻿import { IEditor } from '../interface/editor';
import { ValidatorParam } from '../interface/validator-param';

export function isValidatorDisabled(param: ValidatorParam, editor: IEditor): boolean {
    if (typeof (param.disabled) === 'function') {
        if (param.disabled(editor)) {
            return true;
        }
    } else if (param.disabled) {
        return true;
    }
    return false;
}